var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert"},[_c('div',{staticClass:"alert_icon"},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'exclamation']}})],1),_vm._v(" "),_c('p',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }